import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import baCommon from './locales/ba/common.json'
import baHeader from './locales/ba/header.json'
import baFooter from './locales/ba/footer.json'
import baCountry from './locales/ba/country.json'
import baCheckout from './locales/ba/checkout.json'
import baCart from './locales/ba/cart.json'
import baAuth from './locales/ba/auth.json'
import baHome from './locales/ba/home.json'
import baProduct from './locales/ba/product.json'
import baShop from './locales/ba/shop.json'
import baPages from './locales/ba/pages.json'
import baAccount from './locales/ba/account.json'
import baFavorites from './locales/ba/favorites.json'
import baLegal from './locales/ba/legal.json'

import rsCommon from './locales/rs/common.json'
import rsHeader from './locales/rs/header.json'
import rsFooter from './locales/rs/footer.json'
import rsCountry from './locales/rs/country.json'
import rsCheckout from './locales/rs/checkout.json'
import rsCart from './locales/rs/cart.json'
import rsAuth from './locales/rs/auth.json'
import rsHome from './locales/rs/home.json'
import rsProduct from './locales/rs/product.json'
import rsShop from './locales/rs/shop.json'
import rsPages from './locales/rs/pages.json'
import rsAccount from './locales/rs/account.json'
import rsFavorites from './locales/rs/favorites.json'
import rsLegal from './locales/rs/legal.json'

export const DEFAULT_LOCALE = 'ba'
export const VALID_LOCALES = ['ba', 'rs']

export function countryToLocale(countryCode) {
  if (countryCode === 'rs') return 'rs'
  return 'ba'
}

i18n.use(initReactI18next).init({
  resources: {
    ba: {
      common: baCommon,
      header: baHeader,
      footer: baFooter,
      country: baCountry,
      checkout: baCheckout,
      cart: baCart,
      auth: baAuth,
      home: baHome,
      product: baProduct,
      shop: baShop,
      pages: baPages,
      account: baAccount,
      favorites: baFavorites,
      legal: baLegal,
    },
    rs: {
      common: rsCommon,
      header: rsHeader,
      footer: rsFooter,
      country: rsCountry,
      checkout: rsCheckout,
      cart: rsCart,
      auth: rsAuth,
      home: rsHome,
      product: rsProduct,
      shop: rsShop,
      pages: rsPages,
      account: rsAccount,
      favorites: rsFavorites,
      legal: rsLegal,
    },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: [
    'common',
    'header',
    'footer',
    'country',
    'checkout',
    'cart',
    'auth',
    'home',
    'product',
    'shop',
    'pages',
    'account',
    'favorites',
    'legal',
  ],
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
